import { Delta } from "json-difference";

export const logEditedFields = (editedFields: Delta["edited"]) => {
  if (editedFields.length > 5) {
    console.log(
      "\x1B[1mChanged field values:\x1B[m",
      editedFields.reduce<Record<string, { from: unknown; to: unknown }>>(
        (formattedValue, [path, from, to]) => {
          formattedValue[path] = { from, to };

          return formattedValue;
        },
        {},
      ),
    );
  } else {
    editedFields.forEach(([path, from, to]) => {
      console.group(`\x1B[1mChanged field ${path}:\x1B[m`);
      console.log("\x1B[1mFrom:\x1B[m", from);
      console.log("\x1B[1mTo:\x1B[m", to);
      console.groupEnd();
    });
  }
};
